<template>
  <div class="field" :class="[{ 'p-float-label': float }]">
    <Dropdown :inputProps="inputProps" :id="id" :class="[{ 'p-invalid': v.$error }]" v-model="theModel" v-bind="$props"
      class="custom-input form-control" @blur="v.$touch" :showClear="showClearProp" @change="change" />
    <label v-if="float && id && label" :for="id">{{ label }}</label>
    <small v-if="v.$error || v.$pending.$response" class="p-error">{{ $t('registration.requiredValidationError')
    }}</small>
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import { onUpdated, ref, watch, computed } from "vue";
import useVuelidate from "@vuelidate/core";
import { useI18n } from "vue-i18n";

export default {
  components: { Dropdown },
  props: {
    modelValue: String,
    scope: String,
    rules: Object,
    options: {
      type: [],
      default: [],
    },
    optionLabel: {
      type: String,
      default: "name",
    },
    optionValue: {
      type: String,
      default: "id",
    },
    placeholder: {
      type: String,
      default: "Select an Option",
    },
    dataKey: {
      type: String,
      default: "id",
    },
    emptyMessageProp: {
      type: String,
    },
    showClearProp: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    float: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputProps: {
      type: Object
    }
  },
  emits: ["update:modelValue", "change"],
  async setup(props, { emit }) {
    const { t } = useI18n();
    const emptyMessage = ref(t("cashier.label.no-available-options"));

    const theModel = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    function update(e) {
      emit("update:modelValue", e);
    }

    function change(e) {
      emit("change", { value: e.value });
    }

    const v = useVuelidate(props.rules, theModel, { $scope: props.scope });

    return { v, emptyMessage, update, change, theModel };
  },
};
</script>

<style lang="scss" scoped>
.p-float-label label {
  inset-inline-start: 0.5rem !important;
}
</style>